import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./loadingSpinner.html";
import { WireI18n } from '~/modules/stores/i18nStore';
import { images } from '~/modules/utilities/assetUtilities';
const LOADING_DISPLAY_DELAY_MS = 1000;
class LoadingSpinner extends LightningElement {
  constructor(...args) {
    super(...args);
    this.images = images;
    this.title = void 0;
    this.description = void 0;
    this.showImage = false;
    this.showDelay = LOADING_DISPLAY_DELAY_MS;
    this.imageName = '';
    this.imageSize = void 0;
    this.disableDescription = false;
    this.showLoading = false;
    this.loadingTimeout = undefined;
    this.genericLoadingText = void 0;
  }
  get loadingText() {
    return this.description || this.genericLoadingText;
  }
  get image() {
    return this.imageName ? images[this.imageName] : images.validating;
  }
  get imageCssClass() {
    return this.imageSize ? this.imageSize : 'large';
  }
  i18nConnected(i18n) {
    this.genericLoadingText = i18n.shared.loading;
  }
  connectedCallback() {
    const showDelay = Number(this.showDelay);
    if (isNaN(showDelay) || showDelay <= 0) {
      this.showLoading = true;
      return;
    }

    // Wait 1 second before showing the loading indicator:
    // https://uxmovement.com/navigation/progress-bars-vs-spinners-when-to-use-which/
    this.loadingTimeout = setTimeout(() => {
      this.showLoading = true;
      this.loadingTimeout = undefined;
    }, showDelay);
  }
  disconnectedCallback() {
    if (this.loadingTimeout != null) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = undefined;
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(LoadingSpinner, {
  publicProps: {
    title: {
      config: 0
    },
    description: {
      config: 0
    },
    showImage: {
      config: 0
    },
    showDelay: {
      config: 0
    },
    imageName: {
      config: 0
    },
    imageSize: {
      config: 0
    },
    disableDescription: {
      config: 0
    }
  },
  wire: {
    i18nConnected: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["images", "showLoading", "loadingTimeout", "genericLoadingText"]
});
const __lwc_component_class_internal = _registerComponent(LoadingSpinner, {
  tmpl: _tmpl,
  sel: "appx-loading-spinner",
  apiVersion: 62
});
export default __lwc_component_class_internal;